import UIBuilderModule from 'src/modules/uiBuilder/module';
import uiBuilderSlice from 'src/modules/uiBuilder/slice';

export const moduleList = {
  ...UIBuilderModule,
};

export const reducerList = {
  ...uiBuilderSlice,
};
